const SAFE_PROTOCOLS = ["http:", "https:", "blob:"];

export function isSafeExternalUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return SAFE_PROTOCOLS.includes(parsed.protocol);
  } catch {
    return false;
  }
}

export function openExternalUrl(url: string | null | undefined): void {
  if (!isSafeExternalUrl(url)) return;
  window.open(url as string, "_blank", "noopener,noreferrer");
}
